export default __webpack_public_path__ + "static/media/hobbies.8cf4183b.png";